import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { ProductListComponent } from '../../componentsAdmin/product-list/product-list.component';

@Component({
  selector: 'app-group',
  templateUrl: './group.page.html',
  styleUrls: ['./group.page.scss'],
})
export class GroupPage implements OnInit {
  @ViewChild('productList') productList: ProductListComponent;
  public buttons = [
    {
      name: 'Grupo',
      value: 'multiOptions',
    },
    {
      name: 'Opciones',
      value: 'options',
    },
  ];

  public isUploading = false;
  public segmentValue = 'multiOptions';
  public editing = undefined;
  public savedForm = undefined;
  private _duplicateId = undefined;

  constructor(
    private formSv: FormServices,
    private trSv: TranslateService,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private fileSv: FileService
  ) {}

  ngOnInit() {}

  setSegment(ev) {
    this.savedForm = undefined;
    this.segmentValue = ev;
    this.editing = undefined;
  }

  setLoadedData() {
    this.productList.products = this.productList.products.map((item) => ({
      ...item,
      auxTxt: item.multiOption?.name,
    }));
  }

  async send(ev: FormData) {
    try {
      if (this._duplicateId) {
        ev.set('duplicateId', String(this._duplicateId));
      }
      this.editing && ev.set('id', String(this.editing));
      this.isUploading = true;
      const res: any = await this.httpSv.itemAction(
        ev,
        this.segmentValue,
        this.editing ? 'update' : 'store'
      );
      this.isUploading = false;
      const msg = this.segmentValue !== 'options' ? 'GRUPO' : 'ADICIONAL';
      const tr = this.trSv.instant(`${msg}_GUARDADO_EXITOSAMENTE`);
      await this.uiSv.showToast(tr);
      if (res.status) {
        // this.id = res.data.id;
        this.editing = undefined;
        this.formSv.clearFormSrc.next();
        this.formSv.deleteListProductSrc.next('reloadListProduct');
      }
    } catch (err) {
      console.error(err);
    }
  }

  async setForm({ product, action, changeAction }) {
    try {
      const msg = this.segmentValue !== 'options' ? 'Grupo' : 'Opción';
      if (action === 'copy') {
        this._duplicateId = product.id;
      } else {
        this._duplicateId = undefined;
      }
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction },
        this.editing,
        this.segmentValue,
        msg,
        this.savedForm
      );

      this.editing = id;
      this.savedForm = savedForm;
      this.savedForm.productId = this.savedForm.productId.map((item) => {
        if (Number(item)) {
          return item;
        } else {
          return item.id;
        }
      });
    } catch (err) {
      await this.uiSv.loading?.dismiss();
    }
  }
}
